import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from "react";
import { AlertDialogOverlay, AlertDialogPortal } from "../../components/ui/alert-dialog/index.js";
import { cn } from "../../lib/utils.js";
import {
  contactsModalPanelClass,
  contactsModalPositionerClass,
} from "../contacts/contacts-dialog-presentation.js";

export const CampaignModalContent = forwardRef<
  React.ElementRef<typeof AlertDialogPrimitive.Content>,
  ComponentPropsWithoutRef<typeof AlertDialogPrimitive.Content> & {
    children: ReactNode;
    size?: "default" | "md" | "lg" | "xl";
  }
>(function CampaignModalContent({ className, children, size = "default", ...props }, ref) {
  return (
    <AlertDialogPortal>
      <AlertDialogOverlay />
      <AlertDialogPrimitive.Content
        ref={ref}
        className={contactsModalPositionerClass}
        {...props}
      >
        <div
          className={cn(
            contactsModalPanelClass,
            size === "xl"
              ? "h-[min(92dvh,52rem)] max-h-[min(92dvh,52rem)] w-[min(96vw,66rem)]"
              : size === "lg"
                ? "h-[min(86dvh,42rem)] w-[min(96vw,48rem)]"
                : size === "md"
                  ? "h-fit max-h-[min(86dvh,36rem)] w-[min(94vw,36rem)]"
                  : "w-[min(92vw,36rem)]",
            className,
          )}
          data-campaign-modal-panel
        >
          {children}
        </div>
      </AlertDialogPrimitive.Content>
    </AlertDialogPortal>
  );
});
